import { sessionStatusExpired, sessionStatusParam } from "./types";

export class FetchError extends Error {
  constructor(
    message: string,
    public status: number,
  ) {
    super(message);
    this.name = "FetchError";
  }
}

export const simpleFetcher = (url: string, type: "json" | "text" = "json") =>
  fetch(url).then((res) => {
    if (res.ok) return res[type]();
    if (res.status === 401 && window.location.pathname !== "/login") {
      const redirect = encodeURIComponent(window.location.pathname);
      window.location.replace(
        `/login?${sessionStatusParam}=${sessionStatusExpired}&redirect=${redirect}`,
      );
    }
    throw new FetchError("Failed to fetch data", res.status);
  });
